module.exports = __webpack_public_path__ + "img/logo.973f3911.png";